import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserCalendarRoutingModule } from './user-calendar-routing.module';
import { UserCalendarComponent } from './user-calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';


@NgModule({
  declarations: [UserCalendarComponent],
  imports: [
    CommonModule,
    UserCalendarRoutingModule,
    FullCalendarModule
  ],
  exports:[
    UserCalendarComponent
  ]
})
export class UserCalendarModule { }
